import { goTo } from '@didi/webx-js'
import { showToast, addH5UrlParams } from '../../utils.js'

// 链接跳转
export default function (eventData = {}) {
  try {
    let jumpLink = eventData.target
    if (!jumpLink) return
    const httpReg = /(http|https):\/\/([\w.]+\/?)\S*/
    const onetravelReg = /onetravel:\/\/([\w.]+\/?)\S*/
    jumpLink = addH5UrlParams(jumpLink)
    if (httpReg.test(jumpLink)) {
      goTo({ url: jumpLink })
      return
    }
    if (onetravelReg.test(jumpLink)) {
      goTo({ scheme: jumpLink })
      return
    }
    window.location.href = jumpLink
  } catch (error) {
    showToast('请填写合法的跳转链接！')
  }
}
